export default __webpack_public_path__ + "static/media/template_modal.504d57cc.png";